export const REPLACEMENT_MSG_PLACEHOLDERS = {
  FILE: {
    tag: 'FILENAME',
    txt: 'example.exe',
    description: gettext(
      'The name of a file removed from a content stream because of antivirus file blocking.'
    ),
  },
  VIRUS: {
    tag: 'VIRUS',
    txt: 'example.virus',
    description: gettext(
      'The name of the virus that the antivirus system found in a file.'
    ),
  },
  CONTENTTYPE: {
    tag: 'CONTENTTYPE',
    txt: 'text/html',
    description: gettext('Content type.'),
  },
  URL: {
    tag: 'URL',
    txt: 'www.example.com/',
    description: gettext(
      'The URL of a web page blocked by web filtering or URL blocking, or the URL of a web page with a blocked file that a user attempted to download.'
    ),
  },
  HOSTNAME: {
    tag: 'HOSTNAME',
    txt: 'www.example.com',
    description: gettext('The URL address of host website.'),
  },
  QUARFILENAME: {
    tag: 'QUARFILENAME',
    txt: 'example.exe',
    description: gettext(
      'The name of a file removed from a content stream and added to the quarantine due to an antivirus threat.'
    ),
  },
  NIDS_EVENT: {
    tag: 'EVENT',
    txt: 'tcp_syn_flood',
    description: gettext('The IPS intrusion message for a TCP_SYN_FLOOD.'),
  },
  PROTOCOL: {
    tag: 'PROTOCOL',
    txt: 'http',
    description: gettext(
      'The protocol (HTTP, FTP, FTP, POP3, IMAP, SMTP) in which the FortiGate detected the virus.'
    ),
  },
  SOURCE_IP: {
    tag: 'PATTERN',
    txt: '192.168.x.x',
    description: gettext(
      'The IP address of one of the following: the email server that sent the email containing the virus, the request originator who would have received the blocked file, or the device that attempted to download the email message that the file was removed from.'
    ),
  },
  URL_SOURCE: {
    tag: 'BLOCK',
    txt: 'Blocking Source',
    description: '',
  },
  DEST_IP: {
    tag: 'IP',
    txt: '198.51.100.1',
    description: gettext(
      'The IP address of the device attempting to receive the blocked file.'
    ),
  },
  CRITICAL_EVENT: {
    tag: 'EVENT',
    txt: 'Critical Event',
    description: gettext(
      'Displays the critical event message that triggered the alert email.'
    ),
  },
  QUOTA_TABLE: {
    tag: 'QUOTA',
    txt: '',
    description: '',
  },
  FGT_HOSTNAME: {
    tag: 'HOSTNAME',
    txt: 'CorporateFortiGate',
    description: gettext('Displays the FortiGate hostname.'),
  },
  APPID: {
    tag: 'APPID',
    txt: '15832',
    description: '',
  },
  APPNAME: {
    tag: 'APPNAME',
    txt: 'Facebook',
    description: gettext(
      'Displays the name of the application blocked in the FortiGuard Application Control block page.'
    ),
  },
  APPCAT: {
    tag: 'APPCAT',
    txt: 'Social.Media',
    description: gettext(
      'Displays the FortiGuard Category of the application.'
    ),
  },
  IPS_DESC: {
    tag: 'DESC',
    txt: 'Request Blocked',
    description: '',
  },
  USERNAME: {
    tag: 'USERNAME',
    txt: 'Guest',
    description: gettext(
      'The text entry field where a user can enter his or her username credential to login.'
    ),
  },
  GROUPNAME: {
    tag: 'GROUPNAME',
    txt: 'Guest-group',
    description: gettext('The user group.'),
  },
  POLICY_UUID: {
    tag: 'UUID',
    txt: '35ef0f54-35d5-51e3-ae02-3d6776b41e4d',
    description: '',
  },
  EMAIL_FROM: {
    tag: 'FROM',
    txt: 'from@example.com',
    description: gettext(
      'The email address of the sender of the message that the FortiGate removed the file from.'
    ),
  },
  EMAIL_TO: {
    tag: 'TO',
    txt: 'rcpt@example.com',
    description: gettext(
      'The email address of the intended receiver of the message that the FortiGate removed the file from.'
    ),
  },
  FROM: {
    tag: 'FROM',
    txt: 'from@example.com',
    description: '',
  },
  TO: {
    tag: 'TO',
    txt: 'rcpt@example.com',
    description: '',
  },
  AUTOMATION_FGT_SERIAL: {
    tag: 'SERIAL',
    txt: 'Automation FortiGate serial',
    description: gettext(
      'Serial of the FortiGate that triggered the automation stitch.'
    ),
  },
  AUTOMATION_STITCH_NAME: {
    tag: 'NAME',
    txt: 'Automation stitch name',
    description: gettext('Name of the automation stitch.'),
  },
  AUTOMATION_EMAIL_BODY: {
    tag: 'BODY',
    txt: 'Automation email body',
    description: gettext('Body message of the automation alert email.'),
  },
  CATEGORY: {
    tag: 'DESC',
    txt: 'Personal Websites and Blogs',
    description: gettext('Displays the FortiGuard Category of a website.'),
  },
  SERVICE: {
    tag: 'SERVICE',
    txt: 'HTTP',
    description: gettext('The name of the web filtering service.'),
  },
  FORTINET: {
    tag: 'LOGO',
    txt: 'FORTINET',
    description: gettext('Displays the following text: FORTINET.'),
  },
  FORTIGUARD_WF: {
    tag: 'LOGO',
    txt: 'FORTINET Webfilter',
    description: gettext('Displays the following text: FORTINET Web Filter.'),
  },
  FTGD_RE_EVAL: {
    tag: 'EVAL',
    txt: '',
    description: gettext(
      'This URL link goes to the FortiGuard website, where you can submit a new category rating for the blocked web page.'
    ),
  },
  HTTP_ERR_CODE: {
    tag: 'CODE',
    txt: '404',
    description: gettext('The returned HTTP error code.'),
  },
  HTTP_ERR_DESC: {
    tag: 'DESC',
    txt: 'Not Found',
    description: gettext('The returned HTTP error message.'),
  },
  OVERRIDE: {
    tag: 'OVRD',
    txt: 'override',
    description: gettext(
      'The link to the FortiGuard Web filtering override form. Displays only for users belonging to groups with permission to create FortiGuard web filtering overrides.'
    ),
  },
  OVRD_FORM: {
    tag: 'FORM',
    txt: '',
    description: gettext(
      'The FortiGuard web filter block override form. This tag must be present in the FortiGuard Web filtering override form and should not be used in other replacement messages.'
    ),
  },
  WARNINGLINK: {
    tag: 'URL',
    txt: '',
    description: gettext(
      'If the user wants to proceed to a web page that violates his or her Internet usage policy this warning link appears.'
    ),
  },
  MAGICID: {
    tag: 'MAGICID',
    txt: '',
    description: gettext(
      'The name for hidden controls required in the authentication login page form.'
    ),
  },
  MAGICVAL: {
    tag: 'MAGICVAL',
    txt: '',
    description: gettext(
      'The value of the %%MAGICID%% tag. You must include this hidden control on the authentication login page.'
    ),
  },
  QUESTION: {
    tag: 'QUESTION',
    txt: 'Please enter the required information to continue.',
    description: gettext(
      ' Authentication challenge prompt to enter username and password information on the authentication login page.'
    ),
  },
  USERNAMEID: {
    tag: 'USERNAMEID',
    txt: '',
    description: gettext(
      'The username of the user logging in. You must include this tag in the authentication login page form.'
    ),
  },
  USERNAMEVAL: {
    tag: 'USERNAMEVAL',
    txt: '',
    description: gettext('This tag validates the %%USERNAMEID%% tag.'),
  },
  PASSWORDID: {
    tag: 'PASSWORDID',
    txt: '',
    description: gettext('The password of the user logging in.'),
  },
  TOKENCODE: {
    tag: 'TOKENCODE',
    txt: '',
    description: gettext(
      'The code is a one time password generated by the FortiToken as part of the two factor authentication process.'
    ),
  },
  REQUESTID: {
    tag: 'REQUESTID',
    txt: '',
    description: gettext(
      'A request for identification used in authentication SMS Token page, FortiToken page, and Email Token page.'
    ),
  },
  REQUESTVAL: {
    tag: 'REQUESTVAL',
    txt: '',
    description: gettext(
      'The %%REQUESTID%% tag must be validated with %%REQUESTVAL%% tag for the user to continue to the website.'
    ),
  },
  REDIRID: {
    tag: 'REDIRID',
    txt: '',
    description: gettext(
      'You must include this hidden control in the authentication and CPA login page forms.'
    ),
  },
  PROTURI: {
    tag: 'PROTURI',
    txt: '',
    description: gettext(
      'The value of the %%REDIRID%% tag. You must include this hidden control in the authentication login page form.'
    ),
  },
  USERGROUPID: {
    tag: 'USERGROUPID',
    txt: '',
    description: gettext('The name of the user group.'),
  },
  USERGROUPVAL: {
    tag: 'USERGROUPVAL',
    txt: '',
    description: gettext('This tag validates the %%USERGROUPID%% tag.'),
  },
  KEEPALIVEURL: {
    tag: 'URL',
    txt: '',
    description: gettext(
      'The authentication keep-alive page connects to this URL to renew the connection policy automatically, based on the number of seconds set in the %%TIMEOUT%% tag.'
    ),
  },
  TIMEOUT: {
    tag: 'TIMEOUT',
    txt: '60',
    description: gettext(
      'The configured number of seconds between authentication %%KEEPALIVEURL%% connections.'
    ),
  },
  AUTH_REDIR_URL: {
    tag: 'URL',
    txt: '',
    description: '',
  },
  AUTH_LOGOUT: {
    tag: 'URL',
    txt: '',
    description: gettext('The URL that immediately closes the session.'),
  },
  AUTH_LOGIN: {
    tag: 'URL',
    txt: '',
    description: gettext('The URL that opens the session.'),
  },
  AUTH_POST_URL: {
    tag: 'URL',
    txt: 'example for AUTH_POST_URL',
    description: gettext('The URL to POST log in credentials.'),
  },
  PRINT_CREDENTIALS: {
    tag: 'CREDENTIALS',
    txt: "<ul class=\\user_details\\>    '<li class=\\'user_info\\'><label class=\\'user_info_label\\'>User ID</label>user@example.com</li>'\\    '<li class=\\'user_info\\'><label class=\\'user_info_label\\'>Password</label>XXXXXXX</li>'\\    '<li class=\\'user_info\\'><label class=\\'user_info_label\\'>Email</label>user@example.com</li>'\\    '<li class=\\'user_info\\'><label class=\\'user_info_label\\'>Expiration</label>2012-12-21 00:00:00</li>'\\    '</ul>'",
    description: gettext(
      "Displays the network guest's access credentials: the user ID, password, email, and expiration time."
    ),
  },
  EMAIL_CREDENTIALS: {
    tag: 'CREDENTIALS',
    txt: '*credentials*',
    description: gettext("The email's credentials."),
  },
  USERID: {
    tag: 'USERID',
    txt: 'guest',
    description: gettext(
      'Selects either an auto-generated value, an email address or a specified value.'
    ),
  },
  PASSWORD: {
    tag: 'PASSWORD',
    txt: '123456',
    description: gettext(
      'The input type for a text entry field that prompts users to enter authentication credentials to login, in this case a password.'
    ),
  },
  EXPIRE: {
    tag: 'EXPIRE',
    txt: '4 hours after first successful login',
    description: gettext('Specifies the time until the credential expires.'),
  },
  MOBILEPHONE: {
    tag: 'MOBILEPHONE',
    txt: '555-123-4567',
    description: gettext('Displays the phone number for your mobile phone.'),
  },
  SPONSOR: {
    tag: 'SPONSOR',
    txt: 'none',
    description: gettext(
      'When enabled, a guest can add a sponsor on the form field for guest access.'
    ),
  },
  COMPANY: {
    tag: 'COMPANY',
    txt: 'none',
    description: gettext("The guest user's company name."),
  },
  EMAIL: {
    tag: 'EMAIL',
    txt: 'guest@example.com',
    description: gettext("The guest's email address."),
  },
  SSL_LOGIN_ANYWAY: {
    tag: 'ANYWAY',
    txt: 'Log in Anyway ',
    description: gettext(
      'The %%SSL_LOGIN_ANYWAY%% tag prompts the user to continue with the log in process.'
    ),
  },
  SSL_LOGIN_CANCEL: {
    tag: 'CANCEL',
    txt: 'Cancel',
    description: gettext(
      'The %%SSL_LOGIN_CANCEL%% tag prompts the user to cancel the log in process.'
    ),
  },
  SSL_ACT: {
    tag: 'ACTION',
    txt: '',
    description: gettext(
      'A required SSL VPN message action tag that formats the page form on the FortiGate SSL VPN portal login.'
    ),
  },
  SSL_METHOD: {
    tag: 'METHOD',
    txt: '',
    description: gettext(
      'A method required on the FortiGate SSL VPN portal login page form.'
    ),
  },
  SSL_IMG: {
    tag: 'IMG',
    txt: '',
    description: '',
  },
  SSL_LOGIN: {
    tag: 'LOGIN',
    txt: "<input type=\\text\\ placeholder=\\Name\\>                                    '<input type=\\'password\\' placeholder=\\'Password\\'>'",
    description: gettext(
      'A required tag that provides the login form on the FortiGate SSL VPN portal login page form.'
    ),
  },
  SSL_HIDDEN: {
    tag: 'HIDDEN',
    txt: '<input type=hidden>',
    description: gettext(
      'A required SSL VPN message tag used in the FortiGate SSL VPN portal login page form.'
    ),
  },
  SSL_RESPONSIVE_EXPAND: {
    tag: 'EXPAND',
    txt: "<button type=\\button\\ class=\\bare\\>                                           '<f-icon class=\\'ftnt-hamburger icon-lg\\'></f-icon>' \\                                           '</button>'",
    description: gettext(
      'A required SSL-VPN tag that allows expanding the header on small devices.'
    ),
  },
  SSL_OPTIONS: {
    tag: 'OPTIONS',
    txt: "<div class=\\expandable\\>                                  '<button type=\\'button\\' class=\\'bare\\'>' \\                                  '<f-icon class=\\'ftnt-help-o icon-lg\\'></f-icon>' \\                                  '</button>' \\                                  '<button type=\\'button\\' class=\\'bare\\'>' \\                                  '<f-icon class=\\'ftnt-user-o icon-lg\\'></f-icon>' \\                                  '</button>'",
    description: gettext(
      'A required tag that contains the user controls for an SSL-VPN user.'
    ),
  },
  SSL_STATUS_INFO: {
    tag: 'INFO',
    txt: "<div class=\\flex-row-centered\\>                                     '<div class=\\'info-item\\'>' \\                                     '00:21:36&nbsp' \\                                     '</div>' \\                                     '<div class=\\'info-item\\'>' \\                                     '36 kB&nbsp;' \\                                     '<f-icon class=\\'fa-arrow-down icon-sm\\'></f-icon>' \\                                     '</div>' \\                                     '<div class=\\'info-item\\'>' \\                                     '22 kB&nbsp;' \\                                     '<f-icon class=\\'fa-arrow-up icon-sm\\'></f-icon>' \\                                     '</div></div>'",
    description: gettext('A SSL-VPN tag that shows session stats to the user.'),
  },
  DISCLAIMER_ACT: {
    tag: 'ACTION',
    txt: '',
    description: '',
  },
  DISCLAIMER_METHOD: {
    tag: 'METHOD',
    txt: '',
    description: '',
  },
  ANSWERID: {
    tag: 'ANSWERID',
    txt: '',
    description: gettext(
      'The answer results to whether the user accepts or declines the agreement.'
    ),
  },
  AGREEVAL: {
    tag: 'AGREEVAL',
    txt: '',
    description: gettext(
      'The response when the user clicks to accept the user agreement.'
    ),
  },
  DECLINEVAL: {
    tag: 'DECLINEVAL',
    txt: '',
    description: gettext(
      'The response when the user clicks to decline to the terms of agreement on a disclaimer page.'
    ),
  },
  FAILED_MESSAGE: {
    tag: 'MESSAGE',
    txt: 'Firewall authentication failed. Please try again.',
    description: gettext(
      "The default failure message on the 'auth-login-failed' page."
    ),
  },
  QUOTA_INFO: {
    tag: 'MESSAGE',
    txt: '2097000',
    description: gettext(
      'Displays information about the traffic shaping quota setting that is blocking the user.'
    ),
  },
  URLFILTER_ERROR: {
    tag: 'ERROR',
    txt: 'An error occurred while trying to rate the website using the webfiltering service.',
    description: gettext('The web filtering error message.'),
  },
  URLFILTER_ERROR_DETAIL: {
    tag: 'DETAIL',
    txt: 'Invalid license',
    description: gettext('The reason for the web filtering service error.'),
  },
  VIRUS_REF_URL: {
    tag: 'URL',
    txt: 'http://www.fortinet.com/ve?vid=1',
    description: gettext('Displays a virus reference URL.'),
  },
  'IMAGE:': {
    tag: 'IMAGE',
    txt: '',
    description: '',
  },
  CPAUTH_SSID: {
    tag: 'SSID',
    txt: 'Fortinet',
    description: gettext(
      'Displays the name of the SSID used for captive portal authentication.'
    ),
  },
  CPAUTH_INTF: {
    tag: 'INTF',
    txt: 'lan',
    description: gettext(
      'Displays the name of the interface used for captive portal authentication.'
    ),
  },
  CN: {
    tag: 'CN',
    txt: 'Example CN',
    description: gettext('Displays the Common Name of the certificate.'),
  },
  AUTHORITY: {
    tag: 'AUTHORITY',
    txt: 'Example CA',
    description: gettext('Displays the Certificate Authority.'),
  },
  START_VALID: {
    tag: 'VALID',
    txt: '2009-01-01',
    description: gettext(
      'The certificate is not valid before this start date.'
    ),
  },
  END_VALID: {
    tag: 'VALID',
    txt: '2012-01-01',
    description: gettext('The date the certificate expires.'),
  },
  CERT_CHAIN: {
    tag: 'CHAIN',
    txt: 'Certificate Chain',
    description: '',
  },
  CERT_INVL_REASON: {
    tag: 'REASON',
    txt: '',
    description: '',
  },
  EXTRAINFO: {
    tag: 'MESSAGE',
    txt: '',
    description: gettext(
      'Provides extra help about two-factor authentication.'
    ),
  },
  EXPIREDAYS: {
    tag: 'DAYS',
    txt: '3',
    description: gettext(
      'The number of days before the current password expires and the user needs to change his or her password.'
    ),
  },
  LINK: {
    tag: 'PATTERN',
    txt: 'FortiClientInstaller',
    description: gettext(
      'This link takes the user to the FortiClient Host Security install page to download the Endpoint Control feature.'
    ),
  },
  SOURCE_SN: {
    tag: 'PATTERN',
    txt: 'FG00SN_EXAMPLE00',
    description: gettext(
      'The serial number of the device which is presenting the warning/disclaimer'
    ),
  },
  DST_ADDR_LABEL: {
    tag: 'LABEL',
    txt: 'www.fortinet.com',
    description: gettext('The destination URL that the user entered.'),
  },
  FEATURE_BLOCK_REASONS: {
    tag: 'REASONS',
    txt: 'FortiClient security checking',
    description: gettext(
      'Displays text explaining why the feature is blocked.'
    ),
  },
  PROTOURI: {
    tag: 'URL',
    txt: 'http://www.example.com',
    description: '',
  },
  LAST_SUCCESSFUL_LOGIN: {
    tag: 'LOGIN',
    txt: 'Last Successful Login: None',
    description: gettext("Displays the user's last successful login time."),
  },
  LAST_FAILED_LOGIN: {
    tag: 'LOGIN',
    txt: 'Last Failed Login: None',
    description: gettext("Displays the user's last failed login time."),
  },
  NEW_BUILD_AVAILABLE: {
    tag: 'AVAILABLE',
    txt: 'A new firmware version is available.',
    description: '',
  },
  DURATION: {
    tag: 'DURATION',
    txt: '300',
    description: gettext(
      'The amount of time in the reporting period. You can set this in the user defined protection profile. (FortiOS Carrier only)'
    ),
  },
  USER_MAC: {
    tag: 'MAC',
    txt: '12:34:56:78:9A:BC',
    description: '',
  },
  USER_IP: {
    tag: 'IP',
    txt: '192.168.1.2',
    description: '',
  },
  AP_MAC: {
    tag: 'MAC',
    txt: '12:34:56:78:9A:BC',
    description: '',
  },
  AP_IP: {
    tag: 'IP',
    txt: '192.168.1.1',
    description: '',
  },
  AP_SSID: {
    tag: 'SSID',
    txt: 'wifi',
    description: '',
  },
  AP_NAME: {
    tag: 'NAME',
    txt: 'FortiAP',
    description: '',
  },
  DEVICE_TYPE: {
    tag: 'TYPE',
    txt: 'windows-pc',
    description: '',
  },
  PORTAL_ADDR: {
    tag: 'ADDR',
    txt: 'www.portal.com',
    description: '',
  },
  PAGE_NUM: {
    tag: 'NUM',
    txt: '567890',
    description: '',
  },
  POLICY_ID: {
    tag: 'ID',
    txt: '123',
    description: '',
  },
  RATING_METHOD: {
    tag: 'METHOD',
    txt: 'IP/Domain',
    description: '',
  },
  WAF_SIG_ID: {
    tag: 'ID',
    txt: '20000000',
    description: '',
  },
  WAF_DESC: {
    tag: 'DESC',
    txt: 'Forbidden HTTP method',
    description: '',
  },
  COMMENT: {
    tag: 'COMMENT',
    txt: 'comment',
    description: '',
  },
  METHODID: {
    tag: 'METHODID',
    txt: '',
    description: gettext(
      'The name for hidden controls required in the authentication login page form.'
    ),
  },
  METHODVAL: {
    tag: 'METHODVAL',
    txt: '',
    description: gettext(
      'The value of the %%METHODID%% tag. You must include this hidden control on the authentication login page.'
    ),
  },
  SUBJECT: {
    tag: 'SUBJECT',
    txt: 'Email subject',
    description: '',
  },
  COMPL_FAIL_CAUSES: {
    tag: 'CAUSE',
    txt: 'Causes of Compliance Failure HTML Fragment',
    description: '',
  },
  COMPL_FAIL_REMEDY: {
    tag: 'REMEDY',
    txt: 'Remedial Steps for Resolving Compliance Failure HTML Fragment',
    description: '',
  },
  MIN_FTCL_VER: {
    tag: 'VER',
    txt: '5.6.0',
    description: '',
  },
  INSTALLED_FTCL_VER: {
    tag: 'VER',
    txt: '5.6.0',
    description: '',
  },
  MIN_COMPAT_FTCL_VER: {
    tag: 'VER',
    txt: '5.6.0',
    description: '',
  },
  VULN_LEVELS: {
    tag: 'LEVELS',
    txt: 'high or critical',
    description: '',
  },
  FTCL_INCOMPAT: {
    tag: 'INCOMPAT',
    txt: 'Warning for Incompatible FortiClient HTML Fragment',
    description: '',
  },
  DOWNLOAD_FTCL: {
    tag: 'FTCL',
    txt: 'Download Instructions FortiClient HTML Fragment',
    description: '',
  },
  FTCL_OS_ALLOWED: {
    tag: 'ALLOWED',
    txt: 'Windows 10',
    description: '',
  },
  ICAP_ERR_DESC: {
    tag: 'DESC',
    txt: 'Request Blocked',
    description: '',
  },
  AUTH_SAML: {
    tag: 'URL',
    txt: '',
    description: '',
  },
  ANTIPHISH_MATCH: {
    tag: 'MATCH',
    txt: 'Phishing credential match',
    description: '',
  },
  QR_CODE_DATA_URI: {
    tag: 'URI',
    txt: '',
    description: '',
  },
  FTCL_VPN_NAME: {
    tag: 'NAME',
    txt: 'FortiClient-VPN',
    description: '',
  },
  FTCL_VPN_CONFIG_URL: {
    tag: 'URL',
    txt: '',
    description: '',
  },
  VIDEOFILTER_DESC: {
    tag: 'DESC',
    txt: 'Video category is blocked, category-id=0',
    description: '',
  },
};
